import { createContext, useState, useMemo } from 'react';

export const WhatSelected = Object.freeze({
  TOPIC: 'topic',
  SUBTOPIC: 'subTopic',
  NOTHING: 'nothing',
});


export const TopicsSubTopicsContext = createContext({
    whatSelected: WhatSelected,
    setWhatSelected: () => {},  
    selectedTopicOrSubtopicName: String,
    setSelectedTopicOrSubtopicName: () => {},
    errorTopicsSubTopics: null,
    setErrorTopicsSubTopics: () => {},  
    selectedTopicOrSubtopicIndex: -1, 
    setselectedTopicOrSubtopicIndex: () => {},
    isLoadingTopicsSubTopics: false,
    setIsLoadingTopicsSubTopics: () => {},
});

export const TopicsSubTopicsProvider = ({ children }) => {

    const [whatSelected, setWhatSelected] = useState(WhatSelected.NOTHING);
    const [selectedTopicOrSubtopicName, setSelectedTopicOrSubtopicName] = useState('');
    const [errorTopicsSubTopics, setErrorTopicsSubTopics] = useState(null);
    const [selectedTopicOrSubtopicIndex, setselectedTopicOrSubtopicIndex] = useState(-1);
    const [isLoadingTopicsSubTopics, setIsLoadingTopicsSubTopics] = useState(false);

    // Стабилизируем сеттеры
    const stableSetters = useMemo(() => ({
        setWhatSelected,
        setSelectedTopicOrSubtopicName,
        setErrorTopicsSubTopics,
        setselectedTopicOrSubtopicIndex,
        setIsLoadingTopicsSubTopics,
    }), []);

    const contextValue = useMemo(() => ({
      whatSelected,
      selectedTopicOrSubtopicName,
      errorTopicsSubTopics,
      selectedTopicOrSubtopicIndex,
      isLoadingTopicsSubTopics,
      ...stableSetters
    }), [
      whatSelected,
      selectedTopicOrSubtopicName,
      errorTopicsSubTopics,
      selectedTopicOrSubtopicIndex,
      isLoadingTopicsSubTopics,
    ]);

    return (
        <TopicsSubTopicsContext.Provider value={contextValue}>
        {children}
        </TopicsSubTopicsContext.Provider>
    );
};